import { MenuDivider } from '../Menu/MenuDivider';
import { MenuItem } from '../Menu/MenuItem';
import { MenuItemToggle } from '../Menu/MenuItemToggle';
import { MenuSection } from '../Menu/MenuSection';
import { MenuSubmenu } from '../Menu/MenuSubmenu';
import { Menubar as BaseComponent } from './Menubar';

// Copy some of the menu component to make them easily usable with `Menubar.<SubComponent>`.
const SUB_COMPONENTS = {
    Section: MenuSection,
    Divider: MenuDivider,
    Item: MenuItem,
    ItemToggle: MenuItemToggle,
    Submenu: MenuSubmenu,
} as const;

export const Menubar = Object.assign(BaseComponent, SUB_COMPONENTS);
